import axios from 'axios'

export default {
    loadLocation(locationId) {
        // eslint-disable-next-line
        return axios.get(`${process.env.VUE_APP_API_URL}/locations/`+locationId);
    },
    updateTableService(locationId, status) {
        return axios.post(`${process.env.VUE_APP_API_URL}/locations/`+locationId+'/servicetype', {
            table_service: status
        });
    },
    updatePickUp(locationId, status) {
        return axios.post(`${process.env.VUE_APP_API_URL}/locations/`+locationId+'/servicetype', {
            pick_up: status
        });
    },
    ready(orderId) {
        // eslint-disable-next-line
        return axios.post(`${process.env.VUE_APP_API_URL}/orders/`+orderId+'/ready', {'ready': true});
    },
    pickUp(orderId) {
        // eslint-disable-next-line
        return axios.post(`${process.env.VUE_APP_API_URL}/orders/`+orderId+'/pickup', {'pickup': true});
    },
    remind(orderId) {
        // eslint-disable-next-line
        return axios.post(`${process.env.VUE_APP_API_URL}/orders/`+orderId+'/remind', {'remind': true});
    },
    cancel(orderId) {
        // eslint-disable-next-line
        return axios.post(`${process.env.VUE_APP_API_URL}/orders/`+orderId+'/cancel', {'cancel': true});
    },
    logout(locationId) {
        // eslint-disable-next-line
        return axios.post(`${process.env.VUE_APP_API_URL}/locations/`+locationId+'/logout', {
            logout: true
        });
    }
}
